import { baseSiteEndPoint, buildHeaders } from "./common";
import { clearAllStorage } from "../helpers/storage";
import { getTracker } from "../helpers/tracker";

/**
 * Register a new user account
 * POST /auth/register/
 */
export async function registerUser(email, password) {
  clearAllStorage();

  const response = await fetch(`${baseSiteEndPoint}/user/register/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    const error = {
      status: response.status,
      message: errorResponse,
    };
    throw error;
  }

  const data = await response.json();

  // Store tokens in localStorage
  localStorage.setItem("accessToken", data.access);
  localStorage.setItem("refreshToken", data.refresh);
  localStorage.setItem(
    "accessTokenRenewInterval",
    new Date().getTime() + (data.access_token_renew_interval * 1000)
  );
  localStorage.setItem("userInfo", JSON.stringify(data.user));

  getTracker().setUserID(data.user.username);
  getTracker().setMetadata('userData', JSON.stringify(data.user));

  return data;
}

/**
 * Get available business categories
 * GET /accounts/sellers/categories/
 */
export async function getCategories() {
  const response = await fetch(`${baseSiteEndPoint}/unified/accounts/sellers/categories/`, {
    method: "GET",
    headers: buildHeaders(),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw {
      status: response.status,
      message: errorResponse,
    };
  }

  const data = await response.json();
  // Handle different API response formats
  return data.items || data.results || (Array.isArray(data) ? data : []);
}

/**
 * Get available MCC codes
 * GET /accounts/sellers/mcc/
 */
export async function getMccCodes() {
  const response = await fetch(`${baseSiteEndPoint}/unified/accounts/sellers/mcc/`, {
    method: "GET",
    headers: buildHeaders(),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw {
      status: response.status,
      message: errorResponse,
    };
  }

  const data = await response.json();
  // Handle different API response formats
  const result = data.items || data.results || (Array.isArray(data) ? data : []);
  console.log('MCC API response:', result);
  return result;
}

/**
 * Create a new seller account
 * POST /accounts/sellers/
 */
export async function createSeller(sellerData) {
  const response = await fetch(`${baseSiteEndPoint}/unified/accounts/sellers/`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(sellerData),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw {
      status: response.status,
      message: errorResponse,
    };
  }

  return await response.json();
}

/**
 * Brazilian states for address selection
 */
export const BRAZILIAN_STATES = [
  { code: "AC", name: "Acre" },
  { code: "AL", name: "Alagoas" },
  { code: "AP", name: "Amapá" },
  { code: "AM", name: "Amazonas" },
  { code: "BA", name: "Bahia" },
  { code: "CE", name: "Ceará" },
  { code: "DF", name: "Distrito Federal" },
  { code: "ES", name: "Espírito Santo" },
  { code: "GO", name: "Goiás" },
  { code: "MA", name: "Maranhão" },
  { code: "MT", name: "Mato Grosso" },
  { code: "MS", name: "Mato Grosso do Sul" },
  { code: "MG", name: "Minas Gerais" },
  { code: "PA", name: "Pará" },
  { code: "PB", name: "Paraíba" },
  { code: "PR", name: "Paraná" },
  { code: "PE", name: "Pernambuco" },
  { code: "PI", name: "Piauí" },
  { code: "RJ", name: "Rio de Janeiro" },
  { code: "RN", name: "Rio Grande do Norte" },
  { code: "RS", name: "Rio Grande do Sul" },
  { code: "RO", name: "Rondônia" },
  { code: "RR", name: "Roraima" },
  { code: "SC", name: "Santa Catarina" },
  { code: "SP", name: "São Paulo" },
  { code: "SE", name: "Sergipe" },
  { code: "TO", name: "Tocantins" },
];
